import { getConfig } from 'config/envVars'
import styles from './card.module.css'
// import { Card as CardShape } from '../../../api/src/card/interfaces/card.interface'
import Clickable from 'components/Clickable'
import { useEffect, useState } from 'react'
import classnames from 'classnames'
import CardBack from 'components/CardBack'
import Head from 'next/head'
import CardToBeChosenLater from 'components/CardToBeChosenLater'

const config = getConfig()

type CardShape = {
  id?: number,
  images?: any[],
  textFront: string,
  textInside?: string,
  widthInches?: number,
  heightInches?: number,
}

interface CardProps {
  card: CardShape,
  size?: 'default' | 'small' | 'medium' | 'large',
}

// This whole styles section is a disaster

const getWrapperClassName = (size: CardProps['size']) => {
  if (size === 'small') {
    return styles.cardWrapperSmall
  }
  if (size === 'large') {
    return styles.cardWrapperLarge
  }
  return styles.cardWrapperCenter
}

// const getImageName = (size: CardProps['size']) => {
//   if (size === 'small') {
//     return styles.cardWrapperSmall
//   }
//   if (size === 'large') {
//     return styles.cardWrapperLarge
//   }
//   return styles.cardWrapperCenter
// }

// const getImageContainerClassName = (size: CardProps['size']) => {
//   if (size === 'medium') {
//     return styles.imageContainerMedium
//   }
//   return styles.imageContainer
// }

const Card = ({ card, size = 'default' }: CardProps) => {
  const [isFlipped, setIsFlipped] = useState(false)
  const imageContainerClassNames = classnames(
    styles.imageContainer,
    {
      [styles.imageContainerMedium]: size === 'medium',
      [styles.imageContainerFlipped]: isFlipped,
    },
  )
  const imageClassNames = classnames(
    styles.image,
    {
      [styles.imageSmall]: size === 'small',
      [styles.imageMedium]: size === 'medium',
      [styles.imageLarge]: size === 'large',
    },
  )
  // useEffect(() => {
  //   if (card.id) {
  //     setIsFlipped(false)
  //   }
  // }, [card.id])
  const imageFileName = card.images?.[0]?.filename
  const imageUrl = `${config.imageHostname}${imageFileName}`

  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    setTimeout(() => { setIsLoading(false)}, 1000)
  }, [])
  useEffect(() => {
    if (imageUrl && !isLoading) {
      setIsLoading(true)
      setTimeout(() => { setIsLoading(false)}, 1000)
    }
  }, [imageUrl, setIsLoading])

  console.log({ isLoading })
  return <div className={getWrapperClassName(size)}>
    {/* <div className={styles.cardExtrasWrapper}>
      <Clickable onClick={() => { setIsFlipped(!isFlipped) }}><div className={styles.viewDetailsLink}>{ isFlipped ? 'Hide' : 'View' } Card Details</div></Clickable>
    </div> */}
    <div className={imageContainerClassNames}>
      <Head>
        <link rel='preload' as='image' href={imageUrl} />
      </Head>
      <div className={styles.imageWrapper}>
        <div className={styles.cardExtrasWrapper}>
          <Clickable onClick={() => { setIsFlipped(!isFlipped) }}><div className={classnames(styles.viewDetailsLink, { [styles.viewDetailsLinkLoading]: isLoading })}>{ isFlipped ? 'Hide' : 'View' } Card Details</div></Clickable>
        </div>
        { imageFileName
          ? <Clickable onClick={() => { setIsFlipped(!isFlipped) }}>
            <img src={imageUrl} alt={card.textFront} className={imageClassNames} />
          </Clickable>
          : <div className={classnames(styles.noImageCard, imageClassNames)}>
            <CardToBeChosenLater />
          </div>
        }
        <CardBack
          card={card}
          isFlipped={isFlipped}
          size={ size === 'large' ? 'large' : 'small' }
          setIsFlipped={setIsFlipped}
        />
      </div>
    </div>
  </div>
}

export default Card
